export enum FeedUnitType {
    Fu = 'FU',
    Mj = 'MJ',
}
